import apiDoctorAvatar from 'src/components/common/DoctorAvatarEditor/api/apiDoctorAvatar'
import type { DoctorAvatarProcessResponseItem } from 'src/components/common/DoctorAvatarEditor/api/apiDoctorAvatar'

/**
 * Вариант обработанного аватара для одного угла поворота.
 *
 * Бэкенд отдаёт кадры с фоном и без, плюс опциональный upscale.
 */
export type ProcessedAvatar = {
  cropCoords: string
  upscaleCropCoords: string
  rotationAngle: number
  imageWithBackground: string
  imageWithoutBackground: string
  upscaleWithBackground: string
  upscaleWithoutBackground: string
}

export default function mapProcessedAvatar(
  item: DoctorAvatarProcessResponseItem,
): ProcessedAvatar {
  return {
    cropCoords: item.crop_coords || '',
    upscaleCropCoords: item.upscale_crop_coords || '',
    rotationAngle: item.rotation || 0,
    imageWithBackground: apiDoctorAvatar.toDataUrl(item.image_with_background || ''),
    imageWithoutBackground: apiDoctorAvatar.toDataUrl(item.image_without_background || ''),
    upscaleWithBackground: item.upscale_image_with_background
      ? apiDoctorAvatar.toDataUrl(item.upscale_image_with_background)
      : '',
    upscaleWithoutBackground: item.upscale_image_without_background
      ? apiDoctorAvatar.toDataUrl(item.upscale_image_without_background)
      : '',
  }
}

export function getProcessedAvatarPreview(
  variant: ProcessedAvatar | undefined,
  isCropImage: boolean,
  isUpscaleImage: boolean,
  isUpscalingEnabled: boolean,
) {
  if (!variant) {
    return ''
  }

  if (isUpscalingEnabled && isUpscaleImage) {
    return isCropImage
      ? variant.upscaleWithoutBackground
      : variant.upscaleWithBackground
  }

  return isCropImage
    ? variant.imageWithoutBackground
    : variant.imageWithBackground
}
